export default __webpack_public_path__ + "static/media/Crowfire.68ffc4ea.jpg";